import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { GaIcon } from '~icon';
import { Loader } from '~helpers';
import IconContainer from './IconContainer';
import LabelContainer from './LabelContainer';
import buttonTheme from '../../styles/buttonTheme';
import buttonPropTypes from '../../prop-types/buttonPropTypes';

var Label = function Label(_ref) {
  var skin = _ref.skin,
      icon = _ref.icon,
      spin = _ref.spin,
      size = _ref.size,
      color = _ref.color,
      btnSize = _ref.btnSize,
      isLoading = _ref.isLoading,
      children = _ref.children;
  var theme = useContext(ThemeContext);
  var iconSizeValue = null;

  if (size) {
    iconSizeValue = parseInt("" + size, 10);
  } else {
    iconSizeValue = theme && theme.button && theme.button.iconSize && theme.button.iconSize[btnSize] || buttonTheme.button.iconSize[btnSize];
  }

  var renderIcon = isLoading ? /*#__PURE__*/React.createElement(Loader, {
    skin: skin
  }) : /*#__PURE__*/React.createElement(GaIcon, {
    icon: icon,
    size: iconSizeValue,
    color: color,
    btnSize: btnSize
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconContainer, {
    spin: spin
  }, renderIcon), children && /*#__PURE__*/React.createElement(LabelContainer, {
    hasIcon: icon || isLoading || false,
    sizeValue: iconSizeValue
  }, children));
};

Label.defaultProps = {
  skin: undefined,
  spin: false,
  color: 'currentColor',
  size: null,
  isLoading: false,
  children: null,
  icon: undefined
};
export default Label;